import { fitStyle } from '../../lib/fit';

/**
 * The vehicle-fit badge. Shared by search cards, map pins, and unit rows so a
 * single visual language means the same thing everywhere in the product.
 */
export default function FitPill({ status, size = 'sm', showIcon = true, className = '' }) {
  const style = fitStyle(status);
  const { Icon } = style;
  const sizing = size === 'lg' ? 'px-3 py-1.5 text-sm' : 'px-2 py-0.5 text-[12px]';

  return (
    <span className={`inline-flex items-center gap-1 rounded-full font-semibold ${style.pill} ${sizing} ${className}`}>
      {showIcon && <Icon className={size === 'lg' ? 'h-4 w-4' : 'h-3 w-3'} aria-hidden="true" />}
      {style.label}
    </span>
  );
}
